import React from 'react';
import { SxProps, Theme, ToggleButton, ToggleButtonGroup } from '@mui/material';

type Props = {
  magnitudeUnit: 'PoundsPerSquareFoot' | 'PoundsPerLinearFoot';
  onChange: (magnitudeUnit: 'PoundsPerSquareFoot' | 'PoundsPerLinearFoot') => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  color?: 'standard' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
};

export const PsfPlfToggle = (props: Props) => (
  <ToggleButtonGroup
    sx={props.sx}
    color={props.color}
    disabled={props.disabled}
    value={props.magnitudeUnit}
    size="small"
    exclusive
    onChange={() =>
      props.onChange(props.magnitudeUnit === 'PoundsPerSquareFoot' ? 'PoundsPerLinearFoot' : 'PoundsPerSquareFoot')
    }
  >
    <ToggleButton value="PoundsPerSquareFoot">PSF</ToggleButton>
    <ToggleButton value="PoundsPerLinearFoot">PLF</ToggleButton>
  </ToggleButtonGroup>
);
